"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@emotion/react");

var _materialUiPluginCacheEndpoint = _interopRequireDefault(require("material-ui-plugin-cache-endpoint"));

var _getEmotionCache = _interopRequireDefault(require("./get-emotion-cache"));

var cache = (0, _getEmotionCache.default)(_materialUiPluginCacheEndpoint.default);

var wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  return /*#__PURE__*/_react.default.createElement(_react2.CacheProvider, {
    value: cache
  }, element);
};

exports.wrapRootElement = wrapRootElement;